/* eslint-disable no-useless-constructor */
import feathersClient, { BaseModel, makeServicePlugin } from "../../feathers-client";

class SPPRealTimePrices extends BaseModel {
  constructor(data, options) {
    super(data, options);
  }

  static modelName = "SPPRealTimePrices";
}

const servicePlugin = makeServicePlugin({
  Model: SPPRealTimePrices,
  service: feathersClient.service("data-services/spp/real-time-locational-marginal-prices"),
  idField: "_id",
  nameStyle: "path",
  getters: {},
});

export default servicePlugin;
